
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Punetoshirdicabpickupdrop() {



    const cardData =
    {
        keyword: 'Pune to Shirdi Cab Pickup and Drop Services',
        heading: 'S9 Travels: Pune to Shirdi Cab Pickup and Drop Services',
        headingDescription: 'S9 Travels offers reliable, comfortable, and affordable cab services for your journey from Pune to Shirdi. Whether you are visiting for a religious pilgrimage to the famous Sai Baba Temple or exploring the spiritual ambiance of the town, our cab service ensures a smooth and hassle-free experience. Shirdi is approximately 185 km from Pune, and the journey usually takes around 4 to 5 hours by road. Our well-maintained fleet and professional drivers provide a safe and comfortable ride, with pick-up and drop services at your convenience.',

        top: 'Top Places to Visit in Shirdi with S9 Travels',

"topPlaces": [
    {
      "title": "Sai Baba Temple",
      "description": "The Sai Baba Temple in Shirdi is the main attraction and the primary reason for most visitors. It is one of the most visited religious sites in India, dedicated to the revered saint Sai Baba. The temple is known for its spiritual atmosphere and offers peace, serenity, and blessings to pilgrims from all over the world."
    },
    {
      "title": "Dwarkamai Masjid",
      "description": "Dwarkamai Masjid is a historic mosque that holds great significance for Sai Baba's followers. Sai Baba is believed to have spent a significant amount of time here, and the masjid houses several artifacts related to him. It's a peaceful spot for spiritual reflection and prayer."
    },
    {
      "title": "Chavadi",
      "description": "Chavadi is another important site in Shirdi, where Sai Baba used to rest alternately every night. The building has immense spiritual importance and is visited by devotees to pay their respects to Sai Baba. It is also where Sai Baba’s Padukas (holy sandals) are kept for worship."
    },
    {
      "title": "Sai Teerth Spiritual Theme Park",
      "description": "Sai Teerth is a unique spiritual theme park that offers an immersive experience of Sai Baba's life and teachings. The park includes an interactive museum, light and sound shows, and other attractions that allow visitors to learn about Sai Baba’s journey and his impact on millions of followers."
    },
    {
      "title": "Shirdi Museum",
      "description": "The Shirdi Museum houses several artifacts, personal items, and belongings of Sai Baba, including his wooden seat and other items from his life. It's a great place to explore Sai Baba's legacy and history while understanding his teachings and significance."
    },
    {
      "title": "Shani Shingnapur",
      "description": "Located around 80 km from Shirdi, Shani Shingnapur is a famous temple dedicated to Lord Shani (the planet Saturn). The village is known for its unique tradition of not having any doors on houses, and it’s believed to be protected by Lord Shani himself. It’s a great spot to visit if you’re looking to explore another religious site near Shirdi."
    },
    {
      "title": "Khandoba Temple",
      "description": "Khandoba Temple is located on a hilltop in Shirdi and is dedicated to Lord Khandoba, a popular deity in Maharashtra. The temple provides a scenic view of the town and is an important spot for devotees looking to explore local religious sites."
    },
    {
      "title": "Lendi Baug",
      "description": "Lendi Baug is a garden that was once visited daily by Sai Baba, who used to water the trees and plants there. It is a calm and serene spot for visitors to relax and meditate, with lush greenery and a peaceful atmosphere."
    },
    {
      "title": "Gurusthan",
      "description": "Gurusthan is the place where Sai Baba is said to have appeared for the first time in Shirdi. The site is now a small temple, and it holds great religious importance for Sai Baba’s followers. It is an excellent place to begin your spiritual journey in Shirdi."
    }
],

"services": [
    {
      "name": "Book Pune to Shirdi Pickup Drop Taxi",
      "description": "Traveling from Pune to Shirdi has never been easier with S9 Travels. We offer pickup and drop taxi services for a seamless journey to Shirdi, one of the most revered spiritual destinations in India. Whether you are traveling for a spiritual visit or a peaceful getaway, our services ensure a smooth and comfortable ride both ways."
    },
    {
      "name": "Pune to Shirdi Pickup Drop Cab Booking",
      "description": "Booking a pickup and drop cab with S9 Travels is quick and hassle-free. Simply contact us to schedule your ride from Pune to Shirdi, and we'll ensure that you're picked up from your desired location and dropped off at the Shirdi Sai Baba Temple or any other destination in Shirdi with ease. Our fleet of well-maintained vehicles and experienced drivers guarantee a safe and pleasant journey."
    },
    {
      "name": "Pune to Shirdi One-Way Pickup Drop Taxi",
      "description": "If you're looking for a one-way taxi service for your trip to Shirdi, S9 Travels offers affordable one-way pickup and drop taxi services. You can enjoy the convenience of a direct ride to Shirdi Sai Baba Temple without the worry of a return trip. Our one-way service is ideal for those seeking a quick visit without the need to arrange a round-trip journey."
    },
    {
      "name": "Pune to Shirdi Round Trip Pickup Drop",
      "description": "For those planning to visit Shirdi and return to Pune on the same day or over the weekend, S9 Travels offers a round-trip pickup and drop taxi service. Our round-trip service provides convenience, flexibility, and comfort, so you can relax and focus on your visit to Shirdi without worrying about the travel logistics. We ensure timely arrivals and departures for a hassle-free journey."
    },
    {
      "name": "Pune to Shirdi Drop Service",
      "description": "If you're only looking for a drop service from Pune to Shirdi, S9 Travels offers specialized taxi services that take you directly to your destination in Shirdi. Whether you're going to visit the Shirdi Sai Baba Temple or other places in the area, our drop service ensures you reach your destination safely and comfortably."
    },
    {
      "name": "Pune to Shirdi Pickup Taxi",
      "description": "Need a taxi for a pickup from Pune to Shirdi? S9 Travels offers convenient and reliable pickup taxi services. Our drivers will arrive at your specified location in Pune on time, ensuring you can start your journey to Shirdi without delays. With well-maintained vehicles and professional drivers, you can enjoy a smooth and comfortable ride."
    },
    {
      "name": "Book Pune to Shirdi Drop Taxi",
      "description": "If you're seeking a drop-off service from Pune to Shirdi, S9 Travels is your go-to provider. We offer affordable drop-off taxi services that ensure you reach your destination on time and with ease. Whether you need a single drop-off or have a group of people traveling, we have various vehicle options to suit your needs."
    },
    {
      "name": "Pune to Shirdi Taxi Booking",
      "description": "Booking a taxi from Pune to Shirdi with S9 Travels is simple and straightforward. Our booking process is flexible, and we offer a range of vehicles depending on your preferences and group size. You can book your ride online, over the phone, or even through our app for a smooth and hassle-free experience."
    },
    {
      "name": "Shirdi Temple Taxi from Pune",
      "description": "Visiting the Shirdi Sai Baba Temple? S9 Travels provides dedicated temple taxi services from Pune to Shirdi. Our taxis are perfect for those traveling to Shirdi specifically for the temple visit. Our professional drivers are knowledgeable about the best routes and will ensure that your journey is peaceful and comfortable."
    },
    {
      "name": "Affordable Pune to Shirdi Pickup Drop",
      "description": "Looking for an affordable taxi for your trip from Pune to Shirdi? S9 Travels offers budget-friendly options without compromising on comfort and safety. We make sure that our pricing is transparent and competitive, so you can enjoy a hassle-free trip without worrying about hidden charges."
    },
    {
      "name": "Luxury Taxi for Shirdi from Pune",
      "description": "For those seeking extra comfort and style, S9 Travels offers luxury taxi services for your journey from Pune to Shirdi. Travel in style with our premium fleet, which includes spacious vehicles, plush interiors, and additional amenities for a luxurious experience. Whether you're visiting for a special occasion or simply prefer a high-end experience, our luxury taxis are the perfect choice."
    },
    {
      "name": "Pune to Shirdi Temple Tour",
      "description": "If you're planning a temple tour in Shirdi, S9 Travels provides a convenient and organized taxi service that covers all your travel needs. We offer flexible packages that ensure you can visit all the major temples and landmarks in Shirdi at your own pace. Our drivers will be at your disposal for the entire tour, ensuring a comfortable and spiritual journey."
    },
    {
      "name": "Shirdi Pickup Drop Service",
      "description": "For a simple pickup and drop service to Shirdi, S9 Travels ensures that your journey is comfortable and stress-free. Our drivers are punctual and courteous, and our vehicles are comfortable and clean, allowing you to focus on your visit without the hassle of transportation. We offer both private and Efficient services depending on your needs."
    },
    {
      "name": "Private Cab from Pune to Shirdi",
      "description": "If you're looking for a private and personalized experience, S9 Travels offers private cabs from Pune to Shirdi. Our private cabs are ideal for those who want to travel in comfort, privacy, and style. Whether you’re traveling solo, with family, or in a group, our private taxis offer ample space, comfort, and flexibility to meet your needs."
    }
],

"tableData": [
  ["Book Pune To Shirdi Pickup Drop Taxi", "Pune To Shirdi Pickup Drop Cab Booking"],
  ["Pune To Shirdi One-Way Pickup Drop Taxi", "Pune To Shirdi Round Trip Pickup Drop"],
  ["Pune To Shirdi Drop Service", "Pune To Shirdi Pickup Taxi"],
  ["Book Pune To Shirdi Drop Taxi", "Pune to Shirdi Taxi Booking"],
  ["Shirdi Temple Taxi from Pune", "Affordable Pune to Shirdi Pickup Drop"],
  ["Luxury Taxi for Shirdi from Pune", "Pune to Shirdi Temple Tour"],
  ["Shirdi Pickup Drop Service", "Private Cab from Pune to Shirdi"]
],
"whychoose": [
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "At S9 Travels, we understand the importance of punctuality when planning your visit to Shirdi. Our drivers ensure timely pickups and drop-offs, allowing you to have a smooth and hassle-free journey to the sacred Sai Baba Temple and other attractions in Shirdi."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Vehicles",
    "WhyChoosedescription": "We offer a variety of well-maintained vehicles, including sedans, SUVs, and premium cars, for your trip from Pune to Shirdi. All our vehicles are equipped with air conditioning, spacious interiors, and comfortable seating, ensuring a pleasant and relaxing ride."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our drivers are experienced and professional, familiar with the best routes to Shirdi. They ensure a safe, smooth, and enjoyable journey, prioritizing your comfort and safety throughout the trip."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers competitive and transparent pricing for your Pune to Shirdi trip. There are no hidden charges, and we provide a clear breakdown of costs, so you know exactly what to expect and can enjoy your journey without any worries."
  },
  {
    "WhyChooseheading": "Safe and Comfortable Journey",
    "WhyChoosedescription": "Your safety is our priority. All our vehicles are equipped with modern safety features such as airbags, seat belts, and GPS tracking, ensuring a secure and comfortable ride throughout your journey to Shirdi."
  },
  {
    "WhyChooseheading": "24/7 Availability",
    "WhyChoosedescription": "Whether you’re planning an early morning trip or a late-night return, S9 Travels is available 24/7 to cater to your needs. Our customer service team is ready to assist you with bookings, inquiries, or any other assistance you may require."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Booking a cab for your Pune to Shirdi trip is easy and convenient with S9 Travels. You can book online through our website or mobile app, or you can contact our customer service team for personalized assistance with your booking."
  },
  {
    "WhyChooseheading": "Customized Travel Packages",
    "WhyChoosedescription": "Whether you're visiting Shirdi for religious purposes or leisure, we offer customized travel packages tailored to your specific needs. Let us know your preferences, and we’ll ensure that your trip is special and memorable."
  }
]





















    }



    const faqData = [
        [
          {
            question: 'How can I book a Pune to Shirdi cab with S9 Travels?',
            answer: 'Booking a cab is simple! You can book online through our website or app, or you can contact our customer service team for personalized assistance and help with planning your trip.',
          },
          {
            question: 'What types of vehicles are available for the Pune to Shirdi trip?',
            answer: 'We offer a range of vehicles, including sedans, SUVs, and premium cars. All our vehicles are well-maintained and designed to provide comfort and safety during long trips.',
          },
          {
            question: 'Are the drivers experienced for long-distance travel to Shirdi?',
            answer: 'Yes, all our drivers are highly experienced in long-distance travel and are familiar with the best routes to Shirdi. They ensure a smooth and enjoyable journey.',
          },
          {
            question: 'How do I pay for my Pune to Shirdi cab rental?',
            answer: 'We offer multiple payment options, including cash, credit/debit cards, and online payments via our app, making it convenient for you to pay for your ride.',
          },
          {
            question: 'Can I book a round-trip from Pune to Shirdi?',
            answer: 'Yes, we can arrange a round-trip for you. Simply provide us with your return details, and we’ll ensure a smooth and comfortable return journey from Shirdi.',
          },
          {
            question: 'Are there any extra charges for waiting or detours during the trip?',
            answer: 'Any additional charges, such as waiting time or detours, will be communicated to you upfront, ensuring complete transparency in pricing.',
          },
          {
            question: 'Can I hire a cab for sightseeing in Shirdi?',
            answer: 'Yes, we offer sightseeing services around Shirdi. Explore the famous Sai Baba Temple, local markets, and nearby attractions with the help of our experienced drivers.',
          },
          {
            question: 'What is the luggage allowance for a Pune to Shirdi cab?',
            answer: 'Our vehicles can comfortably accommodate standard luggage. If you have additional luggage or specific requirements, please inform us during the booking process, and we’ll make the necessary arrangements.',
          },
          {
            question: 'Is S9 Travels available for corporate or group travel to Shirdi?',
            answer: 'Yes, we offer corporate and group travel services to Shirdi. Whether it’s a corporate outing or a family trip, we ensure a comfortable and enjoyable experience for everyone.',
          },
          {
            question: 'Why should I choose S9 Travels for my Pune to Shirdi journey?',
            answer: 'S9 Travels guarantees a reliable, comfortable, and affordable journey with professional drivers, well-maintained vehicles, and excellent customer service. We prioritize your safety and comfort, ensuring a smooth and memorable trip to Shirdi.',
          },
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Vikram Patil',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“I booked a cab with S9 Travels for my trip to Shirdi. The vehicle was clean and comfortable, and the driver was very professional. We had a smooth journey, and I felt safe the whole time. Highly recommend S9 Travels for a hassle-free trip!”',
        },
        {
          name: 'Mrs. Aarti Deshmukh',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“Our visit to Shirdi was made more comfortable thanks to S9 Travels. The vehicle was spacious and clean, and the driver was friendly and professional. We’ll definitely book again for our next trip!”',
        },
      ];
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   
    const productSchema = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Pune To Shirdi Cab Pickup Drop Service",
        "description": "Book Pune to Shirdi pickup drop taxi services with S9 Travels. We offer one-way, round-trip, luxury taxis, and affordable car rentals for your Shirdi pilgrimage. Enjoy private cab services, Shirdi temple tours, and pickup-drop services to make your trip comfortable and hassle-free from Pune to Shirdi.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "8569"
        }
      };
      
     
      
      


    return (
        <div>
          <Helmet>
        <title>Pune To Shirdi Cab Pickup Drop Service | Affordable Taxi & Car Rentals | S9 Travels | Contact: +91 8850328441</title>
        <meta 
          name="description" 
          content="Book Pune to Shirdi pickup drop taxi services with S9 Travels. Enjoy one-way, round-trip, luxury taxis, and car rentals. Get affordable and reliable transportation for your Shirdi temple tour, private cab bookings, and pickup drop services from Pune to Shirdi." 
        />
        
        {/* Inject JSON-LD Schema */}
        <script type="application/ld+json">
          {JSON.stringify(productSchema)}
        </script>
      </Helmet>
      
<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/26.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetoshirdicabpickupdrop;